import DescriptionPaneEditorLabel from "./DescriptionPaneEditorLabel";

export default DescriptionPaneEditorLabel;
export { DescriptionPaneEditorLabel };
